import styled from "styled-components";
import PageTemplate from "./PageTemplate";
import { analytics } from "../firebase";
import { logEvent } from "firebase/analytics";
import { useEffect } from "react";

const ImpresumPage = () => {
  useEffect(() => {
    logEvent(analytics, "page_view", {
      firebase_screen: "ImpresumPage",
    });
  }, []);

  return (
    <PageTemplate>
      <Container>
        <Card>
          <Title>Impresum</Title>

          <Section>
            <Row>
              <Label>Naziv medija</Label>
              <Value>Veb portali Ogledalo društva</Value>
            </Row>
            <Row>
              <Label>Registarski broj</Label>
              <Value>IN001557</Value>
            </Row>
            <Row>
              <Label>Datum osnivanja</Label>
              <Value>10.06.2025.</Value>
            </Row>
            <Row>
              <Label>Forma medija</Label>
              <Value>
                Samostalna elektronska izdanja uređivački oblikovane internet
                stranice
              </Value>
            </Row>
            <Row>
              <Label>Jezik</Label>
              <Value>Srpski</Value>
            </Row>
            <Row>
              <Label>Urednica portala</Label>
              <Value>Snežana Žarković Dražić</Value>
            </Row>
            <Row>
              <Label>Telefon</Label>
              <Value>069/2005249</Value>
            </Row>
            <Row>
              <Label>E-pošta</Label>
              <Value>odrustva@gmail.com</Value>
            </Row>
            <Row>
              <Label>Internet adresa</Label>
              <Value>www.ogledalo-drustva.com</Value>
            </Row>
            <Row>
              <Label>Izdato od strane</Label>
              <Value>www.namecheap.com</Value>
            </Row>
          </Section>

          <Divider />

          <Section>
            <SectionTitle>Izdavač</SectionTitle>

            <Row>
              <Label>Poslovno ime</Label>
              <Value>
                Snežana Žarković Dražić PR Veb portali Ogledalo društva
                Aranđelovac
              </Value>
            </Row>
            <Row>
              <Label>Matični broj</Label>
              <Value>68087015</Value>
            </Row>
            <Row>
              <Label>PIB</Label>
              <Value>115088397</Value>
            </Row>
            <Row>
              <Label>Sedište</Label>
              <Value>Ljubomira Nenadovića 26, 34300 Aranđelovac</Value>
            </Row>
          </Section>

          <Divider />

          <Section>
            <SectionTitle>Redakcija</SectionTitle>
            <Value>Snežana Žarković Dražić, novinar</Value>
          </Section>
        </Card>
      </Container>
    </PageTemplate>
  );
};

export default ImpresumPage;

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 2rem 1rem;
`;

const Card = styled.div`
  width: 100%;
  max-width: 800px;
  background: #ffffff;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
`;

const Title = styled.h1`
  margin-bottom: 2rem;
  text-align: center;
  font-size: ${(props) => props.theme.fonts.logo};
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const SectionTitle = styled.h2`
  margin-bottom: 0.5rem;
  font-size: ${(props) => props.theme.fonts.large};
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.5rem 0;

  @media (max-width: ${(props) => props.theme.screen.medium}) {
    flex-direction: column;
  }
`;

const Label = styled.span`
  font-weight: 600;
  color: #555;
`;

const Value = styled.span`
  text-align: right;

  @media (max-width: ${(props) => props.theme.screen.medium}) {
    text-align: center;
  }
`;

const Divider = styled.div`
  height: 1px;
  background: #eee;
  margin: 2rem 0;
`;
